<div class="session-ended-wrapper">
  <div>
    <yc-fa
      icon="sign-out"
      [light]="true"
      class="text-link fa-4x">
    </yc-fa>
  </div>
  <div class="header">
    <yc-i18n
      key="common:hdrGrantsConnectSessionEnded"
      defaultValue="GrantsConnect Session Ended">
    </yc-i18n>
  </div>

  <div>
    <yc-i18n
      key="common:textGrantsConnectSessionEndedDesc"
      defaultValue="You have ended your impersonation session. Please close the current tab.">
    </yc-i18n>  
  </div>
</div>